<template>
  <div>
    <a class="skip-to-content-link" href="#main">
      Skip to content
    </a> 
    <navigation />
    <main id="main">
      <h1>Bubly Homepage</h1>      
      <hero />
      <carousel />
      <promo-carousel />
      <!-- <carousel-burst /> -->
      <mixology />
      <destini-modal />
      <soda-stream />
      <all-smiles />
      <packs />
      <!-- <all-flavors /> -->
      <!-- <n-p-h /> -->
      <!-- <smile /> -->
    </main>
    <bubly-footer />
  </div>
</template>

<script>
  import Navigation from '@/components/Navigation';
  import Hero from '@/components/Hero';
  import DestiniModal from '@/components/DestiniModal';
  import Carousel from '@/components/Carousel';
  import CarouselPromo from '@/components/CarouselPromo';
  // import CarouselBurst from '@/components/CarouselBurst';
  import mixology from '@/components/mixology';
  import Pride from '@/components/Pride';
  import summer from '@/components/summer';
  import Packs from '@/components/Packs';
  import Smile from '@/components/Smile';
  import BublyFooter from '@/components/BublyFooter';
  import NPH from '@/components/NPH';
  import AllSmiles from '@/components/AllSmiles';
  import AllFlavors from '@/components/AllFlavors';
  import SeeBublySide from '@/components/SeeBublySide'
  import SodaStream from '@/components/SodaStream';
  // import FamilyEquality from '@/components/FamilyEquality';

  export default {
    name: 'home',
    components: {
    Navigation,
    Hero,
    DestiniModal,
    NPH,
    Carousel,
    'promo-carousel': CarouselPromo,
    // CarouselBurst,
    mixology,
    Pride,
    summer,
    Packs,
    SeeBublySide,
    SodaStream,
    Smile,
    BublyFooter,
    AllFlavors,
    AllSmiles
},
  };
</script>

<style lang='scss' scoped>
  h1 {
    font-size: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue